import { useEffect, useRef, useState } from "react";

const useImportAmountAreaSelectionField = ({ selectAmountFromExcelCell, area, selectFromAreaName, sheet }) => {
  const [areaValue, setAreaValue] = useState("");
  const inputRef = useRef(null);
  const [currentCursorPosition, setCurrentCursorPosition] = useState(0);

  useEffect(() => {
    setAreaValue(area);
  }, [selectFromAreaName]);

  useEffect(() => {
    if (inputRef && inputRef.current) {
      inputRef.current.setSelectionRange(currentCursorPosition, currentCursorPosition);
    }
  }, [areaValue]);

  useEffect(() => {
    if (!sheet) {
      setAreaValue(null);
      setExcelArea(null);
    } else {
      setExcelArea(areaValue);
    }
  }, [sheet]);

  const setExcelArea = (value: string) => {
    if (areExcelCoordinatesValid(value)) {
      selectAmountFromExcelCell(value);
    } else {
      selectAmountFromExcelCell(null);
    }
  };

  /**
   *
   * @param text  Coordinates of row and columns Excel cell in string format. ex: "A1"
   * @return boolean  True if the text is a valid Excel cell, false otherwise.
   *
   *                  Maximum number of columns: 4
   *                  Maximum number of rows: 4
   */
  const areExcelCoordinatesValid = (text: string) => {
    const regex = /^[A-Z]{1,4}[1-9]\d{0,3}$/;
    return regex.test(text);
  };

  const selectAmountFromExcel = async (e) => {
    inputRef.current = e.currentTarget;
    setCurrentCursorPosition(e.currentTarget.selectionStart);

    const newValue = e.currentTarget.value.toUpperCase();
    setAreaValue(newValue);
    setExcelArea(newValue);
  };

  return { areaValue, selectAmountFromExcel };
};

export default useImportAmountAreaSelectionField;
